import { z } from "zod";

export const TaskPlanUpdate = z
  .object({
    summary: z.string().trim().min(1).max(120),
    steps: z
      .array(
        z.object({
          id: z.string().regex(/^[a-zA-Z0-9_-]{1,64}$/),
          label: z.string().trim().min(1).max(160),
          status: z.enum(["pending", "in_progress", "completed", "blocked"]),
        }),
      )
      .min(1)
      .max(20),
  })
  .superRefine((plan, ctx) => {
    if (new Set(plan.steps.map((step) => step.id)).size !== plan.steps.length)
      ctx.addIssue({ code: "custom", message: "Step ids must be unique", path: ["steps"] });
    if (plan.steps.filter((step) => step.status === "in_progress").length > 1)
      ctx.addIssue({
        code: "custom",
        message: "Only one step may be in progress",
        path: ["steps"],
      });
  });
export type TaskPlanUpdate = z.infer<typeof TaskPlanUpdate>;
